/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ChevronsLeftRight = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "m9 7-5 5 5 5" }],
    ["path", { d: "m15 7 5 5-5 5" }]
  ]
];

export { ChevronsLeftRight as default };
//# sourceMappingURL=chevrons-left-right.js.map
